// src/utils/checkIfAdmin.js
import { doc, getDoc } from "firebase/firestore";
import { auth, db} from "../firebase/firebaseConfig";


export const checkIfAdmin = async (uid) => {
    const adminRef = doc(db, "admins", uid);
    const adminSnap = await getDoc(adminRef);
    return adminSnap.exists();
};

